module.exports = __webpack_public_path__ + "static/media/done.ee3b587d.svg";